import { Select, Typography } from 'seagull';
import { MenuItem } from 'seagull/components/MenuItem';
import { netTermsOptions } from "../../constants";
import pluralize from "../../utils/pluralize";
import { defaultWidth } from "../agreement-controllers/constants";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const NetTermsDropdown = _ref => {
  let {
    netTerms,
    onChange: _onChange,
    isReadOnly,
    testid,
    dropdownWidth = defaultWidth
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Typography, {
      as: "p",
      children: "Set the number of days until the payment is due"
    }), /*#__PURE__*/_jsx(Select, {
      collapseHelperText: false,
      style: {
        marginBlockStart: 8
      },
      disabled: isReadOnly,
      value: netTerms,
      onChange: e => {
        _onChange(+e.target.value);
      },
      testid: testid,
      width: dropdownWidth,
      menuMaxHeight: 200,
      children: netTermsOptions.map((numOfDays, idx) => {
        const value = numOfDays.toString();
        const text = numOfDays === 0 ? 'Upon receipt of invoice' : pluralize('day', numOfDays, true);
        return /*#__PURE__*/_jsx(MenuItem, {
          value: value,
          "data-testid": "".concat(testid, "-option-").concat(idx),
          children: text
        }, value);
      })
    })]
  });
};
export default NetTermsDropdown;